module.exports = [
  '/_next/',
  '/static/',
  '/health-check',
  '/invalidate',
  '/flushall',
  '/opensearch.xml',
]
